var ExportCSVMixin = {
  methods: {
    getCSVData(resultados, literalField, excludeList) {
      if (!excludeList) {
        excludeList = ["__typename", "id"]
      }

      var once = true
      var data = ""
      for (var i = 0; i < resultados.length; i++) {

        for (var j = 0; j < excludeList.length; j++) {
          delete resultados[i][excludeList[j]]
        }

        if (once) { // Esto son las cabeceras
          data += this.getCSVLine(this.translate(literalField, Object.keys(resultados[i])))
          once = false
        }

        data += this.getCSVLine(Object.values(resultados[i]))
      }
      return data
    },
    getCSVLine(array) {
      var line = ""
      for (var i = 0; i < array.length; i++) {
        line += '"' + this.getValue(array[i]) + '"';
        if (i < (array.length - 1)) {
          line += ","
        }
      }
      line += "\n"
      return line
    },
    getValue(cell) {
      if (!cell) return cell // Evitar nulos

      if (typeof cell === 'object' && cell['valor']) // Si es tipo objeto y tiene una propiedad llamada valor
        return cell['valor']

      return cell;
    },
    translate(literalField, array) {
      var translatedArray = []
      for (var i = 0; i < array.length; i++) {
        translatedArray.push(this.$i18n.t(literalField + ".cabecerasCSV." + array[i]))
      }
      return translatedArray
    },
    download(csv, exportFilename) {
      let blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8;'
      });

      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, exportFilename + '.csv');
      }
      else {
        let link = document.createElement("a");
        link.style.display = 'none';
        document.body.appendChild(link);
        if (link.download !== undefined) {
          link.setAttribute('href', URL.createObjectURL(blob));
          link.setAttribute('download', exportFilename + '.csv');
          link.click();
        }
        else {
          csv = 'data:text/csv;charset=utf-8,' + csv;
          window.open(encodeURI(csv));
        }
        document.body.removeChild(link);
      }
    },
  }
};

export default ExportCSVMixin;